import React from 'react'
import { connect } from 'react-redux'
import { CompactPicker } from 'react-color'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsFiletypeItem from "./SetsFiletypeItem"
import SettingsForm from './SettingsForm'

class SetsFiletype extends SettingsForm {

  modelName = 'filetype'

  newItem = {
    filetype_desc: '',
    filetype_active: 1,
    filetype_color: '#ffffff'
  };

  selectColor = () => {
    this.setState({colorPick: true});
  }

  applyColor = color => {
    this.setState({
      data: {
        ...this.state.data,
        filetype_color: color.hex
      },
      colorPick: false
    });
  }

  render() {
    const filetypes = this.props.filetypes.data || [];
    const { search, sort } = this.props.filetypes;
    const { data, errors } = this.state;

    var fltrFiletypes = [];
    for(var key in filetypes){
      if(filetypes.hasOwnProperty(key)){
        const active = filetypes[key].filetype_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + filetypes[key].filetype_desc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrFiletypes.push(filetypes[key]);
        }
      }
    }

    const srtFiletypes = fltrFiletypes.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.filetype_id < b.filetype_id)
         return sort.asc ? -1 : 1
      if(a.filetype_id > b.filetype_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedFiletypes = srtFiletypes ? srtFiletypes.map(filetype =>
      <SetsFiletypeItem key={filetype.filetype_id}
        data={filetype}
      />
    ) : [];
    const colorPick = this.state.colorPick ?
      <div style={{position:'absolute',zIndex:2,right:'15px'}}>
        <CompactPicker
          color={data.filetype_color}
          onChangeComplete={ this.applyColor }
        />
      </div>
      :'';

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.filetype_desc}
              name="filetype_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </div>
        </td>
        <td
          style={{
            backgroundColor:data.filetype_color,
            cursor:'pointer'
          }}
          onClick={this.selectColor}
        >
          {colorPick}
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка направлений</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrFiletypes.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th onClick={() => {this.handleSort('filetype_desc')}}>Название</th>
              <th className="col-sm-1">Цвет</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedFiletypes}
            <tr onClick={this.startAdding}>
              <td colSpan="2"><u>Нажмите, чтобы добавить запись</u></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    filetypes: store.filetypes
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsFiletype);



// WEBPACK FOOTER //
// ./src/components/settings/SetsFiletype.js